import React from 'react';

class Player extends React.Component
{

	render()
	{
		return (
			<div>
				<input className="playerInput" type="text" list="allplayers" id={"player"+ this.props.numPlayer} value={this.props.playerName} onChange={event => this.props.onPlayerNameChange(this.props.numPlayer, event.target.value)}/>
				<datalist id="allplayers">
					{this.props.playerList.map((item) =>
						{
							if (item.isAvailable){
								return <option key={item.name} value={item.name} />
							}
						}
					)}  
				</datalist>
			</div>
		);
	}
}

export default Player;
